import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { QueryRenderer } from "react-relay";

import DocumentsForReviewCSVQuery from "./graphql/DocumentsForReviewCSVQuery";
import DocumentsToReviewQuery from "./graphql/DocumentsForReviewQuery";
import useDocumentsToReveiwReport from "./hooks";

import { environment } from "pstat-anywhere/relay";
import { withLabelContext } from "pstat-anywhere/context_providers/LabelContext";
import { Bucket } from "pstat-anywhere/components/reports/Buckets";
import {
  AdvancedReportPage,
  DefaultActionPanel
} from "pstat-anywhere/components/pages/reports";
import { SearchBarAndFilters } from "pstat-anywhere/components/document_reports/expiring/DocumentsForReviewFilters";

export const Buckets = ({ buckets }) => {
  const { t } = useTranslation();
  let lastStepKey = null;
  if (buckets) {
    const keys = Object.keys(buckets);
    lastStepKey = keys[3];
  }
  return (
    <Fragment>
      <Bucket
        label={t("documentReports.pastDue")}
        count={buckets?.["0"]}
        color="#BB0000"
      />
      <Bucket
        label={t("documentReports.lessThanBucket", { count: 30 })}
        count={buckets?.["30"]}
        color="#B55B00"
      />
      <Bucket
        label={t("documentReports.lessThanBucket", { count: 60 })}
        count={buckets?.["60"]}
        color="#00A429"
      />
      <Bucket
        label={t("documentReports.lessThanBucket", {
          count: lastStepKey ? lastStepKey : ""
        })}
        count={buckets?.[lastStepKey]}
        color="#00A429"
      />
      <Bucket
        label={t("documentReports.greaterThanBucket", {
          count: lastStepKey ? lastStepKey : ""
        })}
        count={buckets?.not_expiring}
        color="#102E4C"
      />
    </Fragment>
  );
};

function DocumentsToReviewReport({ route, router, location, labels }) {
  const { t } = useTranslation();
  const { variables, handleBulkReview, loading } = useDocumentsToReveiwReport({
    location,
    router,
    route,
    labels,
    t
  });
  const { justMine } = variables;
  const tabs = [
    {
      id: "expiring_mine",
      textKey: "documentReports.expiring.tabs.mine",
      path: "policy_reports/expiring/mine"
    },
    {
      id: "expiring_all",
      textKey: "documentReports.expiring.tabs.everyone",
      path: "policy_reports/expiring"
    }
  ];
  const isCheckboxDisabled = rowData => {
    if (rowData.cannotBulkReviewReason === "HAS_DRAFT") {
      return "documentReports.expiring.cannotBulkReview.hasDraft";
    }
    if (rowData.cannotBulkReviewReason === "INACTIVE_AUTHOR") {
      return "documentReports.expiring.cannotBulkReview.inactiveAuthor";
    }
    if (rowData.cannotBulkReviewReason === "SPECIFIC_EXPIRATION_DATE") {
      return "documentReports.expiring.cannotBulkReview.specificExpirationDate";
    }
  };
  return (
    <QueryRenderer
      environment={environment}
      variables={variables}
      query={DocumentsToReviewQuery}
      render={({ props }) => {
        const tableType = props?.documentsToReview?.showBulkReview
          ? "expiring_with_bulk_review"
          : "expiring";
        const documentsToReview = props?.documentsToReview || {};
        const {
          buckets,
          categories,
          documents,
          rssFeedUrl
        } = documentsToReview;
        return (
          <AdvancedReportPage
            csvQueryName="documentsToReviewCsv"
            csvQueryArgs={{ justMine }}
            CSVQuery={DocumentsForReviewCSVQuery}
            variables={variables}
            data={documents}
            route={route}
            router={router}
            location={location}
            tabs={tabs}
            headerText={t("documentReports.expiring.header", {
              documentLabelPlural: labels.documentLabelPlural
            })}
            noContentMessage={t(
              "documentReports.expiring.reportContent.noContentMessage",
              {
                documentLabelPlural: labels.documentLabelPlural.toLowerCase()
              }
            )}
            showActionButtonPanel={true}
            showTabsPanel={true}
            tableType={tableType}
            renderActionPanel={selectedPolicies => (
              <DefaultActionPanel
                selectedItemPks={selectedPolicies}
                actionTextKey={"documentReports.expiring.pendForApprovalButton"}
                onActionButtonClick={handleBulkReview}
                loading={loading}
              />
            )}
            BucketsComponent={() => <Buckets buckets={buckets} />}
            otherTableProps={{ isCheckboxDisabled }}
            isCheckboxDisabled={isCheckboxDisabled}
            rssFeedUrl={rssFeedUrl}
            renderFilterPanel={() => (
              <SearchBarAndFilters
                location={location}
                router={router}
                categories={categories}
              />
            )}
          />
        );
      }}
    />
  );
}

export default withLabelContext(DocumentsToReviewReport);
